<script setup>
import { useRsvpStore } from '@/stores/rsvp/rsvp.store';

defineProps({
  link: {
    type: String,
    required: true,
  },
});

const rsvpStore = useRsvpStore();

const mainColor = rsvpStore.getColors.mainColor;
</script>

<template>
  <a class="place-link" :href="link" target="_blank">
    <div class="place">
      <p class="place-text"><slot></slot></p>
      <svg
        id="Capa_1"
        height="32px"
        width="32px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 255.856 255.856"
        xml:space="preserve"
      >
        <path
          :style="`fill:${mainColor};`"
          d="M127.928,38.8c-30.75,0-55.768,25.017-55.768,55.767s25.018,55.767,55.768,55.767
		s55.768-25.017,55.768-55.767S158.678,38.8,127.928,38.8z M127.928,135.333c-22.479,0-40.768-18.288-40.768-40.767
		S105.449,53.8,127.928,53.8s40.768,18.288,40.768,40.767S150.408,135.333,127.928,135.333z"
        />
        <path
          :style="`fill:${mainColor};`"
          d="M127.928,0C75.784,0,33.362,42.422,33.362,94.566c0,30.072,25.22,74.875,40.253,98.904
		c9.891,15.809,20.52,30.855,29.928,42.365c15.101,18.474,20.506,20.02,24.386,20.02c3.938,0,9.041-1.547,24.095-20.031
		c9.429-11.579,20.063-26.616,29.944-42.342c15.136-24.088,40.527-68.971,40.527-98.917C222.495,42.422,180.073,0,127.928,0z
		 M171.569,181.803c-19.396,31.483-37.203,52.757-43.73,58.188c-6.561-5.264-24.079-26.032-43.746-58.089
		c-22.707-37.015-35.73-68.848-35.73-87.336C48.362,50.693,84.055,15,127.928,15c43.873,0,79.566,35.693,79.566,79.566
		C207.495,112.948,194.4,144.744,171.569,181.803z"
        />
      </svg></div
  ></a>
</template>

<style lang="scss" scoped>
.place {
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: center;
  align-items: center;
}

.place-text {
  font-family: Lato, sans-serif;
  font-size: 1.5em;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration-line: underline;
}

.place-link {
  display: flex;
  justify-content: center;
  width: auto;
}
</style>
